import React from 'react';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";

import LoadingBox from "@components/input/LoadingBox";
import { ListItem, ListItemText } from '@mui/material';

interface Props {
  value: boolean | null;
  onChange: (changed: boolean) => void; 
  // icon?: string;
  size?: number;
  disabled?: boolean;
  name?: string;
  name_display?: () => React.ReactNode;
  tooltip?: string;
}

export default function CheckBox({ 
  value,
  onChange,
  disabled = false,
  // icon = "",
  size = 0,
  tooltip = "",
  name = "",
  name_display
}: Props) {

  const renderName = () => {
    if (name.length > 0) {
      if (name === "Loading") {
        return (
          <LoadingBox />
        );
      } else {
        return (
          <ListItemText primary={ name } />
        );
      }
    }
    return null;
  }

  const size_str = `${size}px`;
  let checkbox: any;
  if (value === null) {
    if (size > 0) {
      checkbox = <CheckBoxIcon style={{ width: size_str, height: size_str, color: "grey" }} />;
    } else {
      checkbox = <CheckBoxIcon style={{ color: "grey" }} />;
    }
  } else if (value) {
    if (size > 0) {
      checkbox = <CheckBoxIcon style={{ width: size_str, height: size_str, color: (disabled ? "grey" : "") }} />;
    } else {
      checkbox = <CheckBoxIcon style={{ color: (disabled ? "grey" : "") }} />;
    }
  } else if (size > 0) {
    checkbox = <CheckBoxOutlineBlank style={{ width: size_str, height: size_str, color: (disabled ? "grey" : "") }} />;
  } else { 
    checkbox = <CheckBoxOutlineBlank style={{ color: (disabled ? "grey" : "") }} />;
  }
  if (name.length > 0 || name_display) {
    const display = name_display ? name_display() : renderName();
    return (
      <ListItem style={{ padding: "2px" }}
        aria-controls="checkbox" aria-haspopup="false"
        title={tooltip} className="clickable"
        onClick={(event: any) => {
          if (!disabled && value !== null) {
            onChange(!value);
          }
        }}>
        { checkbox }
        { display }
      </ListItem>
    );
  } else {
    return (
      <span className="clickable"
        onClick={() => {
          if (!disabled && value !== null) {
            onChange(!value);
          }
        }}>
        { checkbox }
      </span>
    );
  }
}
